import { selector } from "recoil";
import { Api } from "../utils";

export const Profile = selector({
  key: 'Profile',
  get: async () => {
    return await Api.profile();
  },
});